import { MethodCommands, MethodHandler, MethodProperties } from '@lentau/analytics/health-metrics/shared';

import {
  cartModifyHandler,
  cartPromocodeDeleteHandler,
  cartPromocodeAddHandler,
  loyaltyGetAppliablePointsHandler,
  noproductactionsHandler,
  orderBuyerNoteSaveCartHandler,
  paymentTypeSearchHandler,
  cartFromOrderAddHandler,
  responseLookupHandler,
  userModifyHandler,
  orderModifyHandler,
  orderPaymentTypeChangeHandler,
  loyaltyApplyPointsToOrderHandler,
} from './checkout-methods-handlers';
import { MethodPropertiesKey } from '../../shared/consts';

export enum CheckoutMethods {
  OrderBuyerNoteSaveCart = 'orderBuyerNoteSaveCart',
  LoyaltyGetAppliablePointsHandler = 'loyaltyGetAppliablePoints',
  NoproductactionsHandler = 'noproductactions',
  CartModifyHandler = 'cartModify',
  PaymentTypeSearch = 'paymentTypeSearch',
  CartPromocodeDelete = 'cartPromocodeDelete',
  CartPromocodeAdd = 'cartPromocodeAdd',
  CartFromOrderAdd = 'cartFromOrderAdd',
  ResponseLookup = 'responseLookup',
  UserModify = 'userModify',
  OrderModify = 'orderModify',
  OrderPaymentTypeChange = 'OrderPaymentTypeChange',
  LoyaltyApplyPointsToOrder = 'loyaltyApplyPointsToOrder',
}
export const CHECKOUT_HANDLER_LIST: MethodHandler = {
  [CheckoutMethods.OrderBuyerNoteSaveCart]: orderBuyerNoteSaveCartHandler,
  [CheckoutMethods.LoyaltyGetAppliablePointsHandler]: loyaltyGetAppliablePointsHandler,
  [CheckoutMethods.NoproductactionsHandler]: noproductactionsHandler,
  [CheckoutMethods.CartModifyHandler]: cartModifyHandler,
  [CheckoutMethods.PaymentTypeSearch]: paymentTypeSearchHandler,
  [CheckoutMethods.CartPromocodeDelete]: cartPromocodeDeleteHandler,
  [CheckoutMethods.CartPromocodeAdd]: cartPromocodeAddHandler,
  [CheckoutMethods.CartFromOrderAdd]: cartFromOrderAddHandler,
  [CheckoutMethods.ResponseLookup]: responseLookupHandler,
  [CheckoutMethods.UserModify]: userModifyHandler,
  [CheckoutMethods.OrderModify]: orderModifyHandler,
  [CheckoutMethods.OrderPaymentTypeChange]: orderPaymentTypeChangeHandler,
  [CheckoutMethods.LoyaltyApplyPointsToOrder]: loyaltyApplyPointsToOrderHandler,
};

export const CHECKOUT_PROPERTIES_LIST: MethodProperties = new Map([
  [
    CheckoutMethods.OrderBuyerNoteSaveCart,
    [
      {
        key: MethodPropertiesKey.TEAM,
        value: MethodCommands.CH,
      },
    ],
  ],
  [
    CheckoutMethods.LoyaltyGetAppliablePointsHandler,
    [
      {
        key: MethodPropertiesKey.TEAM,
        value: MethodCommands.CH,
      },
    ],
  ],
  [
    CheckoutMethods.NoproductactionsHandler,
    [
      {
        key: MethodPropertiesKey.TEAM,
        value: MethodCommands.CH,
      },
    ],
  ],
  [
    CheckoutMethods.CartModifyHandler,
    [
      {
        key: MethodPropertiesKey.TEAM,
        value: MethodCommands.CH,
      },
    ],
  ],
  [
    CheckoutMethods.PaymentTypeSearch,
    [
      {
        key: MethodPropertiesKey.TEAM,
        value: MethodCommands.CH,
      },
    ],
  ],
  [
    CheckoutMethods.CartPromocodeDelete,
    [
      {
        key: MethodPropertiesKey.TEAM,
        value: MethodCommands.CH,
      },
    ],
  ],
  [
    CheckoutMethods.CartPromocodeAdd,
    [
      {
        key: MethodPropertiesKey.TEAM,
        value: MethodCommands.CH,
      },
    ],
  ],
  [
    CheckoutMethods.CartFromOrderAdd,
    [
      {
        key: MethodPropertiesKey.TEAM,
        value: MethodCommands.CH,
      },
    ],
  ],
  [
    CheckoutMethods.ResponseLookup,
    [
      {
        key: MethodPropertiesKey.TEAM,
        value: MethodCommands.CH,
      },
    ],
  ],
  [
    CheckoutMethods.UserModify,
    [
      {
        key: MethodPropertiesKey.TEAM,
        value: MethodCommands.CH,
      },
    ],
  ],
  [
    CheckoutMethods.OrderModify,
    [
      {
        key: MethodPropertiesKey.TEAM,
        value: MethodCommands.CH,
      },
    ],
  ],
  [
    CheckoutMethods.OrderPaymentTypeChange,
    [
      {
        key: MethodPropertiesKey.TEAM,
        value: MethodCommands.CH,
      },
    ],
  ],
  [
    CheckoutMethods.LoyaltyApplyPointsToOrder,
    [
      {
        key: MethodPropertiesKey.TEAM,
        value: MethodCommands.CH,
      },
    ],
  ],
]);
